
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(185|273|364)|6(339|764|928)|192|2875|7120|7962|8733|9914)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
